/**
 * **Les clés de cache, CENTRALISÉES, en fabrique.**
 *
 * `DOCTRINE.md` §6 : « les clés de cache sont centralisées par feature dans une fabrique,
 * au format tableau préfixé par le nom de la feature. **Une clé improvisée casse
 * l'invalidation en silence.** »
 *
 * **ELLE EST COURTE, ET ELLE LE RESTERA — `CDC-6` NE DONNE QU'UNE ROUTE AU SITE.** §7 : « une
 * seule route publique, et c'est le point le plus important de ce document. **Les huit pages
 * sont du code servi** ; le carrousel est la seule chose qui interroge la base sans compte. »
 * Une fabrique pour une clé peut sembler de trop ; elle existe pour la raison inverse de
 * celle de `web/` — là-bas elle empêche des clés improvisées de diverger, ici elle rend
 * **visible qu'il n'y en a qu'une**, donc qu'une seconde entrée serait une route de plus, et
 * une route de plus sur cette surface est une décision de périmètre.
 *
 * **La connexion n'a pas de clé, et ce n'est pas un oubli** : c'est une **mutation**, elle ne
 * met rien en cache. Et la lecture de session que la page de connexion fait n'en a pas
 * davantage — voir `features/connexion/connexion.ts` pour le motif, qui n'est pas évident.
 */
export const CLES = {
  marques: ['marques'] as const,
} as const;
